// Face Scan Animation
export const FACE_ANIMATION_DURATION = 700
export const FACE_ANIMATION_COMPLETED_DURATION = 300
export const FACE_ANIMATION_INPROGRESS_DURATION = 500
// Face Scan Animation End

// Face Scan Progress
// export const FACE_PROGRESS_DURATION = 0
// export const FACE_PROGRESS_MOBILE_DURATION = 1
// export const FACE_PROGRESS_SPEED = 1

export const FACE_PROGRESS_MOBILE_THRESHOLD = 1000;
export const FACE_PROGRESS_DESKTOP_THRESHOLD = 1000;
export const FACE_PROGRESS_MAX_PROGRESS = 1100;
// Face Scan Progress End

// Document Scan Animation
export const DOCUMENT_ANIMATION_DURATION = 1000
export const DOCUMENT_ANIMATION_COMPLETED_DURATION = 300
export const DOCUMENT_ANIMATION_INPROGRESS_DURATION = 800
// Document Scan Animation End

// Document Scan Progress
export const DOCUMENT_PROGRESS_DURATION = 0
export const DOCUMENT_PROGRESS_MOBILE_DURATION = 3
export const DOCUMENT_PROGRESS_SPEED = 5
// Document Scan Progress End
